import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";
import { ToastBottomEnd } from "views/components/Toast";
import {
  toastEditErrorMessageConfig,
  toastEditSuccessMessageConfig,
} from "config/toastConfig";

const defaultErrors = {
  recurrence_period: [],
  max: [],
};

export const useRecurrenceForm = (initialData) => {
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState(defaultErrors);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: parseInt(value) || 0 }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!verifyTokenExpire()) return;

    try {
      setIsSubmitting(true);
      setErrors(defaultErrors);

      await axios.put(
        `${appConfig.apiDomaine}/configurations/recurrence-alert`,
        formData
      );

      ToastBottomEnd.fire(toastEditSuccessMessageConfig());
    } catch (error) {
      const errorData = error.response?.data?.error || {};
      setErrors({ ...defaultErrors, ...errorData });
      ToastBottomEnd.fire(toastEditErrorMessageConfig());
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  };
};
